import { AstNodeCategory, AstNodeType } from './node';
export class CallExpression {
    constructor(token, func, args) {
        this.token = token;
        this.func = func;
        this.args = args;
        this.nodeType = AstNodeType.CallExpression;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Function() {
        return this.func;
    }
    get Args() {
        return this.args;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return `${this.func.toString()}(${this.args
            .map((p) => p.toString())
            .join(', ')})}`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FsbEV4cHJlc3Npb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2FzdC9DYWxsRXhwcmVzc2lvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsZUFBZSxFQUFFLFdBQVcsRUFBYyxNQUFNLFFBQVEsQ0FBQztBQUVsRSxNQUFNLE9BQU8sY0FBYztJQUN2QixZQUNZLEtBQVksRUFDWixJQUFnQixFQUNoQixJQUFrQjtRQUZsQixVQUFLLEdBQUwsS0FBSyxDQUFPO1FBQ1osU0FBSSxHQUFKLElBQUksQ0FBWTtRQUNoQixTQUFJLEdBQUosSUFBSSxDQUFjO1FBRzlCLGFBQVEsR0FBZ0IsV0FBVyxDQUFDLGNBQWMsQ0FBQztRQUNuRCxpQkFBWSxHQUFvQixlQUFlLENBQUMsVUFBVSxDQUFDO0lBSHhELENBQUM7SUFLSixJQUFJLFFBQVE7UUFDUixPQUFPLElBQUksQ0FBQyxJQUFJLENBQUM7SUFDckIsQ0FBQztJQUVELElBQUksSUFBSTtRQUNKLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQztJQUNyQixDQUFDO0lBRUQsWUFBWTtRQUNSLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUM7SUFDOUIsQ0FBQztJQUVELFFBQVE7UUFDSixPQUFPLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRLEVBQUUsSUFBSSxJQUFJLENBQUMsSUFBSTthQUN0QyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQzthQUN4QixJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQztJQUN4QixDQUFDO0NBQ0oifQ==